import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './EntrantsTeamsChessRunning.css';

const REFRESH_ICON = '\u21BB'; // Clockwise arrow
const PAUSE_ICON = '\u25A0'; // Black square
const PLAY_ICON = '\u25B6'; // Play symbol

// Placeholder component for displaying Chess entrants/teams in Running state
const EntrantsTeamsChessRunning = ({ 
  contest, 
  currentUsername, 
  onTeamSelect, 
  onRefreshData,
  isAutoRefreshEnabled,
  onToggleAutoRefresh,
  refreshError 
}) => {
  // Add countdown state
  const [countdown, setCountdown] = useState(60);

  // Reset countdown when auto-refresh is toggled
  useEffect(() => {
    if (isAutoRefreshEnabled) {
      setCountdown(60);
    }
  }, [isAutoRefreshEnabled]);

  // Handle countdown and refresh
  useEffect(() => {
    let timer;
    if (isAutoRefreshEnabled) {
      if (countdown > 0) {
        timer = setInterval(() => {
          setCountdown(prev => prev - 1);
        }, 1000);
      } else {
        // When countdown hits 0, trigger refresh and reset countdown
        onRefreshData();
        setCountdown(60);
      }
    }
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [isAutoRefreshEnabled, countdown, onRefreshData]);

  // TODO: Implement logic to display Chess teams/entrants and handle selection
  // console.log("EntrantsTeamsChessRunning loaded for contest:", contest);

  // Placeholder rendering
  return (
    <div className="entrants-teams-container entrants-teams-container-chess">
      <div className="entrants-teams-header">
        <span className="header-title-group">
          <h3>Chess Teams</h3>
          {refreshError && (
            <span className="header-error-text">Refresh failed: {refreshError}</span>
          )}
        </span>
        <div className="header-buttons">
          <span className="auto-refresh-text">
            auto-refresh: <span className="countdown-text">{isAutoRefreshEnabled ? `${countdown}s` : 'off'}</span>
          </span>
          <button 
            onClick={onToggleAutoRefresh} 
            className="refresh-button"
            title={isAutoRefreshEnabled ? "Pause auto-refresh" : "Resume auto-refresh"}
          >
            {isAutoRefreshEnabled ? 'on' : 'off'}
          </button>
          <button 
            onClick={onRefreshData} 
            className="refresh-button" 
            title="Manual Refresh"
          >
            {REFRESH_ICON}
          </button>
        </div>
      </div>
      <p>Display Chess team list here.</p>
      {/* Example of how selection might work:
      {contest.entrants?.map((entrant) => (
        <div key={entrant.entryName} onClick={() => onTeamSelect(entrant)}>
          {entrant.entryName} {entrant.username === currentUsername ? '(You)' : ''}
        </div>
      ))}
      */}
    </div>
  );
};

EntrantsTeamsChessRunning.propTypes = {
  contest: PropTypes.object.isRequired,
  currentUsername: PropTypes.string,
  onTeamSelect: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
  isAutoRefreshEnabled: PropTypes.bool.isRequired,
  onToggleAutoRefresh: PropTypes.func.isRequired,
  refreshError: PropTypes.string,
};

export default EntrantsTeamsChessRunning; 